import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, RssIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-white border-t border-gray-100 pt-16 pb-8" data-id="element-75" data-mp="akugkhgfaadb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76" data-mp="5nlyshz6s8cl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-77" data-mp="5pf5fx9suskl">

          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-78" data-mp="q2gn6zdbbfd">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-79" data-mp="3s1m3tmcku7gn">
              <span className="font-signature text-2xl text-coral" data-id="element-80" data-mp="3n3atlaidduxw">HelgiG</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-81" data-mp="3j28seo4w78ta">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Explore */}
          <div data-id="element-82" data-mp="3e249krgii1zw">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-83" data-mp="3e4qh4r3ekhi4">
              {t('footer.explore')}
            </h4>
            <ul className="space-y-2 text-sm text-gray-500" data-id="element-84" data-mp="2kdcz2jub0jmg">
              <li data-id="element-85" data-mp="2kbtgunp37yi1">
                <Link to="/" className="hover:text-coral transition-colors" data-id="element-86" data-mp="2kba3lkadtyac">
                  {t('footer.home')}
                </Link>
              </li>
              <li data-id="element-87" data-mp="2bdpw3tlxf5ra">
                <Link to="/about" className="hover:text-coral transition-colors" data-id="element-88" data-mp="2be9gdgz1u68h">
                  {t('footer.about')}
                </Link>
              </li>
              <li data-id="element-89" data-mp="340u4m8k8a27t">
                <Link to="/services" className="hover:text-coral transition-colors" data-id="element-90" data-mp="342ez5y6jll5o">
                  {t('footer.services')}
                </Link>
              </li>
              <li data-id="element-91" data-mp="2u3fsgl5c7zlb">
                <Link to="/contact" className="hover:text-coral transition-colors" data-id="element-92" data-mp="2u1uzgzyo8opk">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Challenge areas */}
          <div data-id="element-93" data-mp="1ipu4327ay20u">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-94" data-mp="1iq3silcp814f">
              {t('footer.servicesTitle')}
            </h4>
            <ul className="space-y-2 text-sm text-gray-500" data-id="element-95" data-mp="13l99ooch609g">
              <li data-id="element-96" data-mp="13mkb4hig6vxe">
                <Link to="/services/new-to-leadership" className="hover:text-coral transition-colors" data-id="element-97" data-mp="zje7lhmpzium">
                  {t('footer.newToLeadership')}
                </Link>
              </li>
              <li data-id="element-98" data-mp="ptchkkat3qd2">
                <Link to="/services/conflict-and-conversations" className="hover:text-coral transition-colors" data-id="element-99" data-mp="ptuoqbz0bozr">
                  {t('footer.conflictAndConversations')}
                </Link>
              </li>
              <li data-id="element-100" data-mp="fuvlj8x0glk5">
                <Link to="/services/meetings-and-facilitation" className="hover:text-coral transition-colors" data-id="element-101" data-mp="fudfxlogkuzk">
                  {t('footer.meetingsAndFacilitation')}
                </Link>
              </li>
              <li data-id="element-102" data-mp="6w1mzd04dl3y">
                <Link to="/services/leading-in-complexity" className="hover:text-coral transition-colors" data-id="element-103" data-mp="6wjmcii2wfg3">
                  {t('footer.leadingInComplexity')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-104" data-mp="28qz8z1rdxaa8">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-105" data-mp="28rheyq3un2vc">
              {t('footer.connectTitle')}
            </h4>
            <div className="flex space-x-3" data-id="element-106" data-mp="2dor3m3jezai4">
              <a href="https://www.linkedin.com/in/helgig" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="bg-gray-100 p-2 rounded-full text-gray-600 hover:bg-teal hover:text-white transition-colors" data-id="element-107" data-mp="2iivakmsojij7">
                <LinkedinIcon size={20} data-id="element-108" data-mp="1usrh3897gz5x" />
              </a>
              <a href="https://helgig.substack.com" target="_blank" rel="noopener noreferrer" aria-label="Substack" className="bg-gray-100 p-2 rounded-full text-gray-600 hover:bg-coral hover:text-white transition-colors" data-id="element-109" data-mp="1zqszdqyt4ugc">
                <RssIcon size={20} data-id="element-110" data-mp="3f71o5z7kxl9m" />
              </a>
            </div>
            <p className="text-xs text-gray-400 mt-4 leading-relaxed" data-id="element-111" data-mp="3dqnwj7r9qg65">
              {t('footer.substackNote')}
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400" data-id="element-112" data-mp="3np3mv8ih1lel">
          <p data-id="element-113" data-mp="3ipqw4cohbu6q">
            &copy; {new Date().getFullYear()} Helgi Gudmundsson / Orgz ehf. {t('footer.copyright')}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-114" data-mp="it10z8dwzvd">
            <Link to="/privacy" className="hover:text-gray-600 transition-colors" data-id="element-115" data-mp="3rr8ddydmi1x0">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="hover:text-gray-600 transition-colors" data-id="element-116" data-mp="a9nsci0hmpno">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}